export function correctErrorMessages(errorMessage: string | null) {
    if (errorMessage === null) {
        return null;
    }

    switch (errorMessage) {
        case 'House name or number is requered':
            return 'Please enter a house number or building name';
        case 'Please provide street':
            return 'Street is a mandatory field, please complete';
        case 'Please provide town':
            return 'Town or City is a mandatory field, please complete';
        case 'Please provide county':
            return 'County is a mandatory field, please complete';
        case 'Please provide postcode':
            return 'Postcode is a mandatory field, please complete';
        default:
            return errorMessage;
    }
}